<template>
  <div class="pepper-trend" v-inview="{ callback: onInview }">
    <!-- label -->
    <SectionLabel text="辣椒粉濃度"/>
    <!-- chart -->
    <div class="pepper-trend__loading" v-show="isLoading"><SvgSymbol use="#spinner"/></div>
    <div ref="chart" class="pepper-trend__chart"></div>
    <!-- guide -->
    <div class="pepper-trend__guide">
      <span class="pepper-trend__guide-text">資料說明：洪秀柱官方粉絲專頁（ChuChuPepper）的粉絲數變化。</span>
      <span class="pepper-trend__guide-text">資料來源：CrowdTangle.</span>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

const COLOR_WHITE = am4core.color('#ffffff')
const COLOR_CATEGORY = am4core.color('#787878')
const COLOR_VALUE = am4core.color('#4267B2')
const COLOR_GROWTH_UP_VALUE = am4core.color('#e4007f')
const COLOR_GROWTH_DOWN_VALUE = am4core.color('#42b983')
const COLOR_EVENT_RECORD = am4core.color('#2A2A2A')

const EVENT_RECORDS = {
  '2016-01-17': '[bold]2016-01-20[/]\n參選黨主席', // 2016-01-20
  '2016-06-05': '[bold]2016-06-10[/]\n蔡英文分享洪秀柱粉絲專頁', // 2016-06-10
  '2016-10-30': '[bold]2016-11-01[/]\n與習近平會面', // 2016-11-01
  '2019-08-04': '[bold]2019-08-08[/]\n表態參選台南立委' // 2019-08-08
}

const EVENT_RECORD_ICON = require('@/assets/material-adjust.svg')

export default {
  name: 'PepperTrend',
  components: {
    SectionLabel
  },
  props: {
    dataCsv: { type: String, required: true }
  },
  data () {
    return {
      isLoading: false,
      chart: null,
      valueField: 'Page Likes',
      valueGrowthField: 'Page Like Growth',
      categoryField: 'Beginning Of Interval',
      likeGrowthTrendColorField: 'LikeGrowthTrendColor',
      eventRecordField: 'EventRecord',
      eventRecordIconField: 'EventRecordIcon',
      lastIntersectionRatio: 0
    }
  },
  methods: {
    onInview () {
      console.log('PepperTrend inview')
      this.drawChart()
    },
    drawChart () {
      this.isLoading = true
      am4core.useTheme(am4themesAnimated)

      // chart
      let chart = am4core.create(this.$refs.chart, am4charts.XYChart)
      chart.nonScaling = true
      chart.paddingRight = 20
      chart.maskBullets = false
      chart.mouseWheelBehavior = 'zoomX'
      chart.zoomOutButton.parent = chart.tooltipContainer
      chart.zoomOutButton.align = 'right'
      chart.zoomOutButton.valign = 'top'
      // chart.numberFormatter.numberFormat = '#.a'
      // chart.numberFormatter.bigNumberPrefixes = [
      //   { "number": 1e+3, "suffix": "K" },
      //   { "number": 1e+6, "suffix": "M" },
      //   { "number": 1e+9, "suffix": "B" }
      // ]

      // load external data
      chart.dataSource.parser = new am4core.CSVParser()
      chart.dataSource.parser.options.useColumnNames = true
      chart.disableCache = true
      chart.dataSource.url = this.dataCsv

      // preprocess data when csv loaded
      chart.dataSource.adapter.add('parsedData', (data) => {
        this.isLoading = false
        return data
          .filter(row => Number(row[this.valueField]) > 0)
          .map((row, index, arr) => {
            // datetime
            let datetime = row[this.categoryField].split(' ')[0]
            row[this.categoryField] = datetime
            // page like growth
            let lastRow = index > 0 ? arr[index - 1] : null
            if (lastRow && lastRow[this.valueField] > 0) {
              row[this.valueGrowthField] = Number(row[this.valueField]) - Number(lastRow[this.valueField])
            } else {
              row[this.valueGrowthField] = 0
            }
            // custom growth color field
            if (row[this.valueGrowthField] >= 0) {
              row[this.likeGrowthTrendColorField] = COLOR_GROWTH_UP_VALUE
            } else {
              row[this.likeGrowthTrendColorField] = COLOR_GROWTH_DOWN_VALUE
            }
            // custom event record field and icon
            let record = EVENT_RECORDS[datetime]
            if (!record) {
              row[this.eventRecordField] = ''
              row[this.eventRecordIconField] = ''
            } else {
              row[this.eventRecordField] = EVENT_RECORDS[datetime]
              row[this.eventRecordIconField] = EVENT_RECORD_ICON
            }
            return row
          })
      })
      // chart.dataSource.events.on('parseended', (event) => {
      //   console.log('parseended')
      //   // console.log(event.target.data)
      //   event.target.data = event.target.data
      //     .filter(row => Number(row[this.valueField]) > 0)
      //     .map((row, index, arr) => {
      //       // datetime
      //       let datetime = row[this.categoryField]
      //       row[this.categoryField] = datetime.split(' ')[0]
      //       // page like growth
      //       let lastRow = index > 0 ? arr[index - 1] : null
      //       if (lastRow && lastRow[this.valueField] > 0) {
      //         row[this.valueGrowthField] = Number(row[this.valueField]) - Number(lastRow[this.valueField])
      //       } else {
      //         row[this.valueGrowthField] = 0
      //       }
      //       // custom growth color field
      //       if (row[this.valueGrowthField] >= 0) {
      //         row[this.likeGrowthTrendColorField] = COLOR_GROWTH_UP_VALUE
      //       } else {
      //         row[this.likeGrowthTrendColorField] = COLOR_GROWTH_DOWN_VALUE
      //       }
      //       // custom event record field
      //       row[this.eventRecordField] = EVENT_RECORDS[datetime] || ''
      //       return row
      //     })
      // })

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = this.categoryField
      // categoryAxis.startLocation = 0.5
      // categoryAxis.endLocation = 0.5
      // categoryAxis.renderer.minGridDistance = 100
      // categoryAxis.renderer.grid.template.location = 0.5;
      categoryAxis.renderer.line.strokeOpacity = 1
      categoryAxis.renderer.line.strokeWidth = 2
      categoryAxis.renderer.line.stroke = COLOR_CATEGORY
      categoryAxis.renderer.labels.template.fill = COLOR_CATEGORY
      // categoryAxis.renderer.opposite = true
      categoryAxis.tooltip.align = 'middle'
      categoryAxis.tooltip.valign = 'middle'
      // categoryAxis.renderer.labels.template.adapter.add('text', function (label, target, key) {
      //   console.log(label)
      //   return label
      // })
      // categoryAxis.adapter.add('getTooltipText', function (text, target, key) {
      //   return `>>> ${text.split(' ')[0]} <<<`
      // })

      let valueGrowthNumberFormatter = new am4core.NumberFormatter()
      valueGrowthNumberFormatter.numberFormat = '#.a'
      valueGrowthNumberFormatter.bigNumberPrefixes = [
        { number: 1e+3, 'suffix': '千' }
      ]

      let valueGrowthAxis = new am4charts.ValueAxis()
      chart.yAxes.push(valueGrowthAxis)
      valueGrowthAxis.numberFormatter = valueGrowthNumberFormatter
      valueGrowthAxis.baseValue = 0
      valueGrowthAxis.tooltip.disabled = true
      valueGrowthAxis.title.text = '每周變化 (人)'
      valueGrowthAxis.title.fill = COLOR_GROWTH_UP_VALUE
      // valueGrowthAxis.title.layout = 'none'
      valueGrowthAxis.renderer.line.strokeOpacity = 1
      valueGrowthAxis.renderer.line.strokeWidth = 2
      valueGrowthAxis.renderer.line.stroke = COLOR_GROWTH_UP_VALUE
      valueGrowthAxis.renderer.labels.template.fill = COLOR_GROWTH_UP_VALUE
      // valueGrowthAxis.renderer.opposite = false
      // valueGrowthAxis.renderer.grid.template.disabled = true

      let valueGrowthSeries = new am4charts.LineSeries()
      chart.series.push(valueGrowthSeries)
      valueGrowthSeries.name = '每周變化'
      valueGrowthSeries.dataFields.valueY = this.valueGrowthField
      valueGrowthSeries.dataFields.categoryX = this.categoryField
      valueGrowthSeries.yAxis = valueGrowthAxis
      valueGrowthSeries.minBulletDistance = 20
      valueGrowthSeries.fillOpacity = 0.1
      valueGrowthSeries.fill = COLOR_GROWTH_UP_VALUE
      valueGrowthSeries.stroke = COLOR_GROWTH_UP_VALUE
      valueGrowthSeries.strokeWidth = 2
      // valueGrowthSeries.tensionX = 0.77
      valueGrowthSeries.tooltip.background.cornerRadius = 20
      valueGrowthSeries.tooltip.background.strokeOpacity = 0
      valueGrowthSeries.tooltip.pointerOrientation = 'vertical'
      valueGrowthSeries.tooltip.label.minWidth = 40
      valueGrowthSeries.tooltip.label.minHeight = 40
      valueGrowthSeries.tooltip.label.textAlign = 'middle'
      valueGrowthSeries.tooltip.label.textValign = 'middle'
      valueGrowthSeries.tooltip.getFillFromObject = false
      // valueGrowthSeries.tooltip.background.fill = COLOR_GROWTH_UP_VALUE
      valueGrowthSeries.tooltip.background.propertyFields.fill = this.likeGrowthTrendColorField
      // valueGrowthSeries.tooltip.dy = -5
      // valueGrowthSeries.tooltipText = '{valueY.value}'
      valueGrowthSeries.adapter.add('tooltipText', (text, target) => {
        let data = target.tooltipDataItem.dataContext
        let value = data[this.valueGrowthField]
        let sign = value > 0 ? '+' : ''
        return `${sign}${value} 人`
      })

      let valueGrowthBullet = new am4charts.CircleBullet()
      valueGrowthSeries.bullets.push(valueGrowthBullet)
      valueGrowthBullet.fill = COLOR_WHITE
      valueGrowthBullet.propertyFields.stroke = this.likeGrowthTrendColorField
      let valueGrowthBulletHover = valueGrowthBullet.states.create('hover')
      valueGrowthBulletHover.properties.scale = 1.3

      let valueGrowthRange = valueGrowthAxis.createSeriesRange(valueGrowthSeries)
      valueGrowthRange.value = 0
      valueGrowthRange.endValue = -100000
      valueGrowthRange.contents.stroke = COLOR_GROWTH_DOWN_VALUE
      valueGrowthRange.contents.fill = COLOR_GROWTH_DOWN_VALUE
      valueGrowthRange.contents.fillOpacity = 0.2

      let valueNumberFormatter = new am4core.NumberFormatter()
      valueNumberFormatter.numberFormat = '#.a'
      valueNumberFormatter.bigNumberPrefixes = [
        { number: 1e+3, 'suffix': '千' },
        { number: 1e+4, 'suffix': '萬' }
      ]

      let valueAxis = new am4charts.ValueAxis()
      chart.yAxes.push(valueAxis)
      valueAxis.numberFormatter = valueNumberFormatter
      valueAxis.baseValue = 0
      valueAxis.tooltip.disabled = true
      valueAxis.title.text = '粉絲數 (人)'
      valueAxis.title.fill = COLOR_VALUE
      // valueAxis.title.layout = 'none'
      valueAxis.renderer.line.strokeOpacity = 1
      valueAxis.renderer.line.strokeWidth = 2
      valueAxis.renderer.line.stroke = COLOR_VALUE
      valueAxis.renderer.labels.template.fill = COLOR_VALUE
      valueAxis.renderer.opposite = true
      valueAxis.renderer.grid.template.disabled = true

      let valueSeries = new am4charts.LineSeries()
      chart.series.push(valueSeries)
      valueSeries.name = '粉絲數'
      valueSeries.dataFields.valueY = this.valueField
      valueSeries.dataFields.categoryX = this.categoryField
      valueSeries.yAxis = valueAxis
      valueSeries.minBulletDistance = 20
      valueSeries.fill = COLOR_VALUE
      valueSeries.strokeWidth = 2
      // valueSeries.tensionX = 0.77
      valueSeries.tooltip.background.cornerRadius = 20
      valueSeries.tooltip.background.strokeOpacity = 0
      valueSeries.tooltip.pointerOrientation = 'vertical'
      valueSeries.tooltip.label.minWidth = 40
      valueSeries.tooltip.label.minHeight = 40
      valueSeries.tooltip.label.textAlign = 'middle'
      valueSeries.tooltip.label.textValign = 'middle'
      valueSeries.tooltip.getFillFromObject = false
      valueSeries.tooltip.background.fill = COLOR_VALUE
      // valueSeries.tooltip.dy = -5
      valueSeries.tooltipText = '粉絲數 {valueY.value}'

      let valueBullet = new am4charts.CircleBullet()
      valueSeries.bullets.push(valueBullet)
      valueBullet.stroke = COLOR_WHITE
      valueBullet.strokeWidth = 4
      let valueBulletHover = valueBullet.states.create('hover')
      valueBulletHover.properties.scale = 1.3

      let eventSeries = new am4charts.LineSeries()
      chart.series.push(eventSeries)
      eventSeries.name = '事件'
      eventSeries.dataFields.valueY = this.valueGrowthField
      eventSeries.dataFields.categoryX = this.categoryField
      eventSeries.yAxis = valueGrowthAxis
      eventSeries.hiddenInLegend = true
      eventSeries.fillOpacity = 0
      eventSeries.strokeWidth = 0

      let eventBullet = new am4charts.Bullet()
      eventSeries.bullets.push(eventBullet)
      let eventBulletIcon = eventBullet.createChild(am4core.Image)
      eventBulletIcon.propertyFields.href = this.eventRecordIconField
      eventBulletIcon.width = 20
      eventBulletIcon.height = 20
      eventBulletIcon.horizontalCenter = 'middle'
      eventBulletIcon.verticalCenter = 'middle'
      let eventBulletLabel = eventBullet.createChild(am4core.Label)
      eventBulletLabel.propertyFields.text = this.eventRecordField
      eventBulletLabel.fontSize = 16
      // eventBulletLabel.maxWidth = 250;
      // eventBulletLabel.wrap = true;
      // eventBulletLabel.truncate = false;
      eventBulletLabel.fill = COLOR_EVENT_RECORD
      eventBulletLabel.strokeWidth = 0
      eventBulletLabel.horizontalCenter = 'middle'
      eventBulletLabel.verticalCenter = 'middle'
      eventBulletLabel.dy = -25

      let scrollbarX = new am4charts.XYChartScrollbar()
      scrollbarX.series.push(valueGrowthSeries)
      scrollbarX.series.push(valueSeries)
      scrollbarX.dy = -20
      chart.scrollbarX = scrollbarX
      // scrollbarX.parent = chart.bottomAxesContainer

      let legend = new am4charts.Legend()
      chart.legend = legend

      let cursor = new am4charts.XYCursor()
      cursor.behavior = 'panX'
      cursor.xAxis = categoryAxis
      // cursor.snapToSeries = valueGrowthSeries
      chart.cursor = cursor

      // valueGrowthSeries.events.on('shown', () => {
      //   eventSeries.show()
      // })
      // valueGrowthSeries.events.on('hidden', () => {
      //   eventSeries.hide()
      // })

      // zoom to custom index range
      // chart.events.on('datavalidated', function (event) {
      //   let chart = event.target
      //   let len = chart.data.length
      //   categoryAxis.zoomToIndexes(Math.round(len * 0.5), Math.round(len * 1), false, true)
      // })

      this.chart = chart
    },
    onIntersection (entries) {
      if (entries[0].intersectionRatio === 1) {
        this.$ga('newmedia.send', {
          'hitType': 'event',
          'eventCategory': 'Read',
          'eventAction': 'Visible',
          'eventLabel': 'Visible_FBfansChart'
        })
        console.log(`@${this.$options.name} [trendIntersection]`)
        this.observer.unobserve(this.$el)
      }
    }
  },
  beforeDestroy () {
    this.chart && this.chart.dispose()
  },
  activated () {
    this.observer = new IntersectionObserver(this.onIntersection, {
      root: null,
      rootMargin: '0px 0px',
      threshold: [1.0]
    })

    this.observer.observe(this.$el)
  },
  mounted () {
    // this.drawChart()
  }
}
</script>

<style lang="scss">
.pepper-trend {
  position: relative;
  @include use-layer(&);

  .section-label__title {
    color: #1a1a1a;
  }

  &__loading {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    color: #e4007f;
    width: 60px;
    height: 60px;
    transform: translate(-50%, -50%);
  }

  &__chart {
    width: 100%;
    max-width: 1360px;
    height: 500px;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", sans-serif;

    @include rwd($RWD_TABLET_SMALL) {
      width: 98%;
      margin: 50px auto 0 auto;
    }
  }

  &__guide {
    margin: 0 22px;
    color: #1a1a1a;
    // line-height: 1.875em;
    // text-align: justify;
    // text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      width: 90%;
      max-width: 450px;
      margin: 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      max-width: 500px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {}
  }

  &__guide-text {
    display: block;
    font-size: 0.875em;
    font-weight: bold;
    line-height: 2.143em;
    @include rwd($RWD_DESKTOP) {
      font-size: 1em;
      line-break: 1.875em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      // text-align: center;
    }
  }
}
</style>
